const countryNameFormatter =
  typeof Intl !== "undefined" && Intl.DisplayNames
    ? new Intl.DisplayNames(["en"], { type: "region" })
    : null;

export const getCountryLabel = (countryCode) => {
  if (typeof countryCode !== "string") {
    return "Unknown";
  }

  const normalizedCountryCode = countryCode.trim();

  if (!normalizedCountryCode || normalizedCountryCode === "Unknown") {
    return "Unknown";
  }

  const regionCode = normalizedCountryCode.toUpperCase();

  if (!countryNameFormatter || !/^[A-Z]{2}$/.test(regionCode)) {
    return normalizedCountryCode;
  }

  try {
    return countryNameFormatter.of(regionCode) || normalizedCountryCode;
  } catch (error) {
    return normalizedCountryCode;
  }
};
